import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// 1. Updated Import for v6
import { generateClient } from '@aws-amplify/api';

// 2. Initialize the client (Outside the component)
const client = generateClient();

const getNewestSensorEvent = `
  query GetNewestEvent($limit: Int) {
    listSAMSTSensorEvents(limit: $limit) {
      items {
        PK
        SK
        sensor_type
        payload {
          angle_x
          angle_y
          angle_z
          battery
          light
          pir
          temperature
        }
      }
    }
  }
`;

const listSAMSTSensorEvents = `
  query ListSAMSTSensorEvents {
    listSAMSTSensorEvents {
      items {
        PK
        SK
        sensor_type
        payload {
          angle_x angle_y angle_z
          battery light pir
          temperature
        }
      }
    }
  }
`;

export default function DatabasePage() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNewest = async () => {
      try {
		console.log("get latest sensor data packet");
        const result = await client.graphql({
          query: getNewestSensorEvent,
          variables: { limit: 1 } // Fetch only the top 1
        });
  
		console.log("RAW DATA FROM AWS:", result.data.listSAMSTSensorEvents.items[0]);
        const items = result.data.listSAMSTSensorEvents.items;
        if (items.length > 0) {
          setEvents([items[0]]); // Store only the single newest item
        }
        setLoading(false);
      } catch (err) {
        console.error("Error fetching newest event:", err);
        setLoading(false);
      }
    };
  
    fetchNewest();
  }, []);

  return (
    <div style={{ padding: 24, fontFamily: 'sans-serif' }}>
      <h1>Database Page</h1>
      <Link to="/">Go back Home</Link>
      
      <div style={{ marginTop: 20 }}>
        <h2>Newest Sensor Event</h2>
        
        {loading ? (
          <div>Loading newest entry...</div>
        ) : events.length > 0 ? (
          // Render the first (and only) item in the events array
          <div style={{ 
            border: '1px solid #ccc', 
            borderRadius: '8px', 
            padding: '20px', 
            maxWidth: '500px',
            backgroundColor: '#f9f9f9',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            <div style={{ marginBottom: '10px' }}>
              <strong>Device ID (PK):</strong> {events[0].PK}
            </div>
            <div style={{ marginBottom: '10px' }}>
              <strong>Timestamp (SK):</strong> {events[0].SK}
            </div>
            <div style={{ marginBottom: '15px' }}>
              <span style={{ 
                backgroundColor: '#e0e0e0', 
                padding: '4px 8px', 
                borderRadius: '4px',
                fontSize: '0.9em',
                fontWeight: 'bold'
              }}>
                {events[0].sensor_type}
              </span>
            </div>
  
            <hr />
  
            <div style={{ marginTop: '15px' }}>
              <h4 style={{ margin: '0 0 10px 0' }}>Payload Data:</h4>
              
              {/* Conditional Rendering based on sensor_type */}
              {(events[0].sensor_type === 'tilt' || events[0].sensor_type === 'IMU') && (
                <div>
                  <p>Angle X: {events[0].payload?.angle_x ?? 'N/A'}</p>
                  <p>Angle Y: {events[0].payload?.angle_y ?? 'N/A'}</p>
                  <p>Angle Z: {events[0].payload?.angle_z ?? 'N/A'}</p>
                </div>
              )}
  
              {events[0].sensor_type === 'PIR' && (
                <div>
                  <p>Motion Detected: {events[0].payload?.pir ? '🔴 YES' : '🟢 NO'}</p>
                  <p>Light Level: {events[0].payload?.light}</p>
                  <p>Battery: {events[0].payload?.battery}%</p>
                </div>
              )}
  
              {events[0].sensor_type === 'TEMP' && (
                <div>
                  <p>Temperature: {events[0].payload?.temperature}°C</p>
                  <p>Battery: {events[0].payload?.battery}%</p>
                </div>
              )}
            </div>
          </div>
        ) : (
          <p>No sensor events found in DynamoDB.</p>
        )}
      </div>
    </div>
  );
}